import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useSession } from '@/auth/useSession';

function PrivateRoute() {
  const { session, loading } = useSession();
  const location = useLocation();

  const isRegisterClientRoute = location.pathname === '/register-client';
  const isClientBookingRoute = location.pathname.startsWith('/client-booking');

  // 1. Mientras carga Supabase — mismo lenguaje visual que el loader de Login
  //    (gradiente + logo), para que no haya un flash brusco de un "Cargando..."
  //    plano antes de que aparezca la app real. La barra pulsa en opacidad
  //    (en vez de deslizarse) para que, se corte cuando se corte `loading`,
  //    nunca se vea "a medias".
  if (loading) {
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center gap-6 px-6 overflow-hidden">
        <div
          className="absolute inset-0 dark:hidden"
          style={{
            background:
              'linear-gradient(170deg, #103254 0%, #103254 25%, #1a4a6e 45%, #3d7fa0 68%, #a8cfe0 84%, #e8f4f8 95%, #ffffff 100%)',
          }}
        />
        <div
          className="absolute inset-0 hidden dark:block"
          style={{
            background:
              'linear-gradient(170deg, #050807 0%, #0a1a16 22%, #123a30 42%, #103254 60%, #0a0f14 82%, #000000 100%)',
          }}
        />

        <motion.img
          src="https://ijolbckmgiwomizpzrae.supabase.co/storage/v1/object/public/bookoll/logos/logobookoll.png"
          alt="Bookoll"
          className="relative z-10 h-12"
          initial={{ scale: 0.85, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5 }}
        />

        <div className="relative z-10 w-full max-w-xs h-1.5 rounded-full bg-white/15 overflow-hidden">
          <motion.div
            className="h-full w-full rounded-full"
            style={{
              background: 'linear-gradient(90deg, #288E7F 0%, #34a894 100%)',
            }}
            animate={{ opacity: [0.35, 1, 0.35] }}
            transition={{ duration: 1, repeat: Infinity, ease: 'easeInOut' }}
          />
        </div>
      </div>
    );
  }

  // 2. Permitir rutas públicas especiales aunque no haya sesión
  if (!session && (isRegisterClientRoute || isClientBookingRoute)) {
    return <Outlet />;
  }

  // 3. Sin sesión → login
  if (!session) {
    return <Navigate to="/" replace />;
  }

  // 4. Sesión válida
  return <Outlet />;
}

export default PrivateRoute;